import React, { useState } from 'react';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.submitContactForm(formData);
      toast.success('Message sent successfully! We\'ll get back to you soon.');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      toast.error(error.message || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    header: {
      background: '#f7f7f7',
      padding: '60px 24px',
      textAlign: 'center'
    },
    title: { fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' },
    subtitle: { color: '#555', maxWidth: '600px', margin: '0 auto' },
    container: { maxWidth: '1100px', margin: '0 auto', padding: '60px 24px' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px' },
    contactInfo: {},
    infoTitle: { fontSize: '1.5rem', fontWeight: '600', marginBottom: '24px' },
    infoItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
      marginBottom: '24px'
    },
    infoIcon: {
      width: '48px',
      height: '48px',
      background: '#1a3a5c',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.25rem',
      flexShrink: 0
    },
    infoLabel: { fontWeight: '600', marginBottom: '4px' },
    infoValue: { color: '#555' },
    form: {},
    formTitle: { fontSize: '1.5rem', fontWeight: '600', marginBottom: '24px' },
    formGroup: { marginBottom: '20px' },
    label: { display: 'block', fontWeight: '500', marginBottom: '8px' },
    input: {
      width: '100%',
      padding: '14px 16px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '1rem'
    },
    textarea: {
      width: '100%',
      padding: '14px 16px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '1rem',
      minHeight: '150px',
      resize: 'vertical'
    },
    submitBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      width: '100%',
      padding: '14px',
      background: '#1a3a5c',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer'
    }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>Contact Us</h1>
        <p style={styles.subtitle}>
          Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
        </p>
      </header>

      <section style={styles.container}>
        <div style={styles.grid} className="contact-grid">
          <div style={styles.contactInfo}>
            <h2 style={styles.infoTitle}>Get in Touch</h2>

            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FiMapPin /></div>
              <div>
                <div style={styles.infoLabel}>Address</div>
                <div style={styles.infoValue}>Gravesend, Kent, United Kingdom</div>
              </div>
            </div>

            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FiPhone /></div>
              <div>
                <div style={styles.infoLabel}>Phone</div>
                <div style={styles.infoValue}>07577 952535</div>
                <div style={styles.infoValue}>07715 512267</div>
                <div style={styles.infoValue}>07853 083370</div>
              </div>
            </div>

            <div style={styles.infoItem}>
              <div style={styles.infoIcon}><FiMail /></div>
              <div>
                <div style={styles.infoLabel}>Email</div>
                <div style={styles.infoValue}>info@kasbiastays.co.uk</div>
              </div>
            </div>

            <div style={{ marginTop: '40px', padding: '24px', background: '#f7f7f7', borderRadius: '12px' }}>
              <h3 style={{ fontWeight: '600', marginBottom: '12px' }}>Availability</h3>
              <p style={{ color: '#555', marginBottom: '8px' }}>We're available 7 days a week to assist with your booking.</p>
              <p style={{ color: '#555' }}>Response time: Within 2 hours during daytime</p>
            </div>

            <div style={{ marginTop: '20px', padding: '24px', background: '#1a3a5c', borderRadius: '12px', color: 'white' }}>
              <h3 style={{ fontWeight: '600', marginBottom: '12px', color: '#d4a5a5' }}>Book Direct & Save!</h3>
              <p style={{ color: 'rgba(255,255,255,0.95)' }}>Get 10% off when you book directly through our website.</p>
            </div>
          </div>

          <div style={styles.form}>
            <h2 style={styles.formTitle}>Send a Message</h2>
            <form onSubmit={handleSubmit}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Name *</label>
                <input
                  type="text"
                  style={styles.input}
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email *</label>
                <input
                  type="email"
                  style={styles.input}
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Phone</label>
                <input
                  type="tel"
                  style={styles.input}
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Subject</label>
                <select
                  style={styles.input}
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                >
                  <option value="">Select a subject</option>
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Booking Question">Booking Question</option>
                  <option value="Corporate Booking">Corporate Booking</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Feedback">Feedback</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Message *</label>
                <textarea
                  style={styles.textarea}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                />
              </div>

              <button type="submit" style={styles.submitBtn} disabled={loading}>
                {loading ? 'Sending...' : (<><FiSend /> Send Message</>)}
              </button>
            </form>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .contact-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </>
  );
};

export default Contact;
